import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import { c as i } from "./index.CxSWpsOB.js";
const m = ({
  height: a,
  width: t,
  useAnimation: s = !0,
  isDarkMode: e = !1,
  borderRadius: n = "4px",
  classNames: o,
  testId: d
}) => /* @__PURE__ */ r.jsx("div", { className: i(e ? "tw-bg-gray-800" : "tw-bg-gray-200", {
  "tw-animate-pulse": s,
  "tw-w-[400px]": !t,
  "tw-h-[400px]": !a,
  "tw-rounded-4": !a
}, o), style: {
  width: t,
  height: a,
  borderRadius: n
}, "aria-busy": "true", "aria-hidden": "true", "data-testid": d, children: /* @__PURE__ */ r.jsx("span", { className: "tw-sr-only", children: "Loading..." }) });
export {
  m as S
};
//# sourceMappingURL=Skeleton.OMEfZdRC.js.map
